import { cn } from '@/lib/utils'
import { StatusAprovacao } from '@acme/core'
import { XIcon } from 'lucide-react'
import React from 'react'

interface IProps {
    status: string
}

export function SimpleChip({ status }: IProps) {
    switch (status) {
        case StatusAprovacao.PENDENTE:
        case StatusAprovacao.PENDENTE_EXCLUSAO:
            return <Chip label="Pendente" color="warning" />
        case StatusAprovacao.APROVADO:
            return <Chip label="Aprovado" color="success" />
        case StatusAprovacao.REPROVADO:
            return <Chip label="Reprovado" color="error" />
        default:
            return <Chip label={status.toString()} color="info" />
    }
}

interface CustomChipProps extends React.HTMLAttributes<HTMLDivElement> {
    label: React.ReactNode
    color?: 'success' | 'error' | 'warning' | 'info'
    onDelete?: (_ignored: any) => any
}

export function Chip({
    label,
    color,
    className,
    onDelete,
    ...props
}: CustomChipProps) {
    let bg = ''
    switch (color) {
        case 'success':
            bg = 'bg-success'
            break
        case 'error':
            bg = 'bg-error'
            break
        case 'warning':
            bg = 'bg-warning'
            break
        case 'info':
            bg = 'bg-info'
            break
        default:
            bg = 'bg-accent text-primary-foreground'
            break
    }

    return (
        <div
            className={cn(
                'rounded-full px-3 py-2',
                'text-white text-sm',
                'flex justify-center items-center',
                bg,
                className,
            )}
            {...props}
        >
            {label}
            {!!onDelete && (
                <div
                    className={cn(
                        'hover:cursor-pointer ml-2 hover:bg-white/20 rounded-full',
                        'flex items-center justify-center p-1',
                    )}
                    title="Remover"
                >
                    <XIcon onClick={onDelete} className="size-4" />
                </div>
            )}
        </div>
    )
}
